module.exports = parcelRequire.resolve("8Sr3O");